"use strict";
/**
 * We redefine our algebra components to use interfaces instead of type unions.
 * Thereby opening up the algebra for unknown extensions
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionTypes = exports.Types = void 0;
var algebra_transformations_1_2_1 = require("@traqula/algebra-transformations-1-2");
Object.defineProperty(exports, "Types", { enumerable: true, get: function () { return algebra_transformations_1_2_1.Types; } });
Object.defineProperty(exports, "ExpressionTypes", { enumerable: true, get: function () { return algebra_transformations_1_2_1.ExpressionTypes; } });
//# sourceMappingURL=Algebra.js.map